import $aYCBL$intldialogarAEmjs from "../intl/dialog/ar-AE.mjs";
import $aYCBL$intldialogbgBGmjs from "../intl/dialog/bg-BG.mjs";
import $aYCBL$intldialogcsCZmjs from "../intl/dialog/cs-CZ.mjs";
import $aYCBL$intldialogdaDKmjs from "../intl/dialog/da-DK.mjs";
import $aYCBL$intldialogdeDEmjs from "../intl/dialog/de-DE.mjs";
import $aYCBL$intldialogelGRmjs from "../intl/dialog/el-GR.mjs";
import $aYCBL$intldialogenUSmjs from "../intl/dialog/en-US.mjs";
import $aYCBL$intldialogesESmjs from "../intl/dialog/es-ES.mjs";
import $aYCBL$intldialogetEEmjs from "../intl/dialog/et-EE.mjs";
import $aYCBL$intldialogfiFImjs from "../intl/dialog/fi-FI.mjs";
import $aYCBL$intldialogfrFRmjs from "../intl/dialog/fr-FR.mjs";
import $aYCBL$intldialogheILmjs from "../intl/dialog/he-IL.mjs";
import $aYCBL$intldialoghrHRmjs from "../intl/dialog/hr-HR.mjs";
import $aYCBL$intldialoghuHUmjs from "../intl/dialog/hu-HU.mjs";
import $aYCBL$intldialogitITmjs from "../intl/dialog/it-IT.mjs";
import $aYCBL$intldialogjaJPmjs from "../intl/dialog/ja-JP.mjs";
import $aYCBL$intldialogkoKRmjs from "../intl/dialog/ko-KR.mjs";
import $aYCBL$intldialogltLTmjs from "../intl/dialog/lt-LT.mjs";
import $aYCBL$intldialoglvLVmjs from "../intl/dialog/lv-LV.mjs";
import $aYCBL$intldialognbNOmjs from "../intl/dialog/nb-NO.mjs";
import $aYCBL$intldialognlNLmjs from "../intl/dialog/nl-NL.mjs";
import $aYCBL$intldialogplPLmjs from "../intl/dialog/pl-PL.mjs";
import $aYCBL$intldialogptBRmjs from "../intl/dialog/pt-BR.mjs";
import $aYCBL$intldialogptPTmjs from "../intl/dialog/pt-PT.mjs";
import $aYCBL$intldialogroROmjs from "../intl/dialog/ro-RO.mjs";
import $aYCBL$intldialogruRUmjs from "../intl/dialog/ru-RU.mjs";
import $aYCBL$intldialogskSKmjs from "../intl/dialog/sk-SK.mjs";
import $aYCBL$intldialogslSImjs from "../intl/dialog/sl-SI.mjs";
import $aYCBL$intldialogsrSPmjs from "../intl/dialog/sr-SP.mjs";
import $aYCBL$intldialogsvSEmjs from "../intl/dialog/sv-SE.mjs";
import $aYCBL$intldialogtrTRmjs from "../intl/dialog/tr-TR.mjs";
import $aYCBL$intldialogukUAmjs from "../intl/dialog/uk-UA.mjs";
import $aYCBL$intldialogzhCNmjs from "../intl/dialog/zh-CN.mjs";
import $aYCBL$intldialogzhTWmjs from "../intl/dialog/zh-TW.mjs";

var $a2ff044afa5f7f63$exports = {};


































$a2ff044afa5f7f63$exports = {
    "ar-AE": $aYCBL$intldialogarAEmjs,
    "bg-BG": $aYCBL$intldialogbgBGmjs,
    "cs-CZ": $aYCBL$intldialogcsCZmjs,
    "da-DK": $aYCBL$intldialogdaDKmjs,
    "de-DE": $aYCBL$intldialogdeDEmjs,
    "el-GR": $aYCBL$intldialogelGRmjs,
    "en-US": $aYCBL$intldialogenUSmjs,
    "es-ES": $aYCBL$intldialogesESmjs,
    "et-EE": $aYCBL$intldialogetEEmjs,
    "fi-FI": $aYCBL$intldialogfiFImjs,
    "fr-FR": $aYCBL$intldialogfrFRmjs,
    "he-IL": $aYCBL$intldialogheILmjs,
    "hr-HR": $aYCBL$intldialoghrHRmjs,
    "hu-HU": $aYCBL$intldialoghuHUmjs,
    "it-IT": $aYCBL$intldialogitITmjs,
    "ja-JP": $aYCBL$intldialogjaJPmjs,
    "ko-KR": $aYCBL$intldialogkoKRmjs,
    "lt-LT": $aYCBL$intldialogltLTmjs,
    "lv-LV": $aYCBL$intldialoglvLVmjs,
    "nb-NO": $aYCBL$intldialognbNOmjs,
    "nl-NL": $aYCBL$intldialognlNLmjs,
    "pl-PL": $aYCBL$intldialogplPLmjs,
    "pt-BR": $aYCBL$intldialogptBRmjs,
    "pt-PT": $aYCBL$intldialogptPTmjs,
    "ro-RO": $aYCBL$intldialogroROmjs,
    "ru-RU": $aYCBL$intldialogruRUmjs,
    "sk-SK": $aYCBL$intldialogskSKmjs,
    "sl-SI": $aYCBL$intldialogslSImjs,
    "sr-SP": $aYCBL$intldialogsrSPmjs,
    "sv-SE": $aYCBL$intldialogsvSEmjs,
    "tr-TR": $aYCBL$intldialogtrTRmjs,
    "uk-UA": $aYCBL$intldialogukUAmjs,
    "zh-CN": $aYCBL$intldialogzhCNmjs,
    "zh-TW": $aYCBL$intldialogzhTWmjs
};


export {$a2ff044afa5f7f63$exports as default};
//# sourceMappingURL=intlStrings.mjs.map
